import { useCallback } from "react";
import { useNavigate } from "react-router";
import { replaceNavigateToPattern } from "../replaceNavigateToPattern.js";
function useAppNavigate() {
  const navigate = useNavigate();
  return useCallback(
    (to, options) => {
      return navigate(replaceNavigateToPattern(to, options == null ? void 0 : options.params), options);
    },
    [navigate]
  );
}
export {
  useAppNavigate
};
